var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShoulders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "71px",
    height: "20px",
    viewBox: "0 0 71 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shoulders") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Humanuculus",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    fillOpacity: 0.195858829
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard-Copy-32",
    transform: "translate(-180.000000, -91.000000)",
    fill: "#1E428A"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Front-Body---Selections",
    transform: "translate(175.074098, 42.681852)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.2850755,48.3552712 C40.8243494,48.3136419 37.3803725,48.3857429 55.9486883,48.3552712 C61.9246559,50.4870292 68.4423155,52.428141 71.7390859,55.1048157 C74.5862502,57.4164515 75.9818555,61.4954988 75.925902,67.3419575 C37.8621941,67.2941535 14.3126746,67.2941535 5.27734329,67.3419575 C7.80626133,53.2401077 6.38641044,55.2704953 25.2850755,48.3552712 Z",
    id: "Shoulders"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoulders);
export default __webpack_public_path__ + "static/media/Shoulders.bfc03fbe90ca321bd260fe3a9812e484.svg";
export { ForwardRef as ReactComponent };